import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  collectionFromModel,
  validateCollectionCondition,
  type CollectionState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const COLLECTION = (
  Details: React.ComponentType<ConditionTypeDetailsProps<CollectionState>>,
): ConditionType<CollectionState, Condition.Collection> => ({
  name: CONDITION_NAMES[Condition.COLLECTION],
  description(state) {
    return t("Collections: {{collections}}", { collections: state.join(", ") });
  },
  Details(props: ConditionTypeDetailsProps<CollectionState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model) {
    return collectionFromModel(model);
  },
  toModel(state) {
    return { type: Condition.COLLECTION, collections: state };
  },
  valid(state) {
    return validateCollectionCondition(state).valid;
  },
});
